import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ProjetoEquipe } from '../../../models/projeto-equipe.model';
import { ProjetoEquipeCapacidadeExecucaoService } from '../../../services/projeto-equipe-capacidade-execucao.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { AtualizacoesAudit } from '../../../models/atualizacoes-audit.model';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';

@Component({
  selector: 'app-equipe-capacidade-execucao-edit',
  templateUrl: './equipe-capacidade-execucao-edit.component.html',
  styleUrls: ['./equipe-capacidade-execucao-edit.component.scss'],
})
export class EquipeCapacidadeExecucaoEditComponent
  extends BaseFormComponent<ProjetoEquipe>
  implements OnInit
{
  actionLabel: string = 'Novo';
  responsabilidadesList: Array<{ id: number; label: string }> = [];
  idProjeto: any;
  canSave: boolean = false;
  audit: AtualizacoesAudit;

  constructor(
    private myService: ProjetoEquipeCapacidadeExecucaoService,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService,
    private router: Router
  ) {
    super(activatedRoute);
  }

  ngOnInit(): void {
    this.loaded();
    this.responsabilidadesList =
      this.activatedRoute.snapshot.data.responsabilidadesList;

    if (this.entity) {
      this.idProjeto = this.entity.pp_id;
      this.canSave = this.entity.canSave;
    } else {
      let currentUrl = this.router.url;
      const regex = /projeto\/(\d+)\/equipe/;
      const match = currentUrl.match(regex);

      if (match) {
        this.idProjeto = match[1];
      } else {
        console.log('ID não encontrado');
      }

      this.canSave = true;
    }
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl('', [
        Validators.required,
        Validators.maxLength(150),
      ]),
      organization: new FormControl('', Validators.maxLength(150)),
      department: new FormControl('', Validators.maxLength(150)),
      email: new FormControl('', [Validators.email, Validators.maxLength(150)]),
      fone: new FormControl('', Validators.maxLength(11)),
      equiprole: new FormControl(),
      pp_id: new FormControl(''),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);

      this.audit = {
        equip_member_id: this.entity.id,
      };
    }
  }

  voltar() {
    this.navigation.back(['pre-projeto/projeto/' + this.idProjeto + '/equipe']);
  }

  getDataCreate(): ProjetoEquipe {
    let data: ProjetoEquipe;
    data = Object.assign({}, data, this.form.value);
    data.pp_id = this.idProjeto;
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService
            .update(this.getDataCreate(), this.entity?.id)
            .subscribe({
              next: (res: ProjetoEquipe) => {
                this.msgSuccess('Cadastro alterado com sucesso!');
                EventSharedService.get('auditRefresh').emit();
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error.message);
                this.loaded();
              },
            })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: ProjetoEquipe) => {
              this.msgSuccess('Cadastro criado com sucesso!');
              this.navigation.replace(['pre-projeto/projeto/equipe/', res.id]);
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error.message);
              this.loaded();
            },
          })
        );
      }
    } else {
      this.markAsDirty();
    }
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.myService.delete(this.entity?.id).subscribe({
      next: (res) => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace([
            'pre-projeto/projeto/' + this.idProjeto + '/equipe',
          ]);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }
}
